import * as Yup from "yup";

export const runValidations = (schema, data) => {
  try {
    schema.validateSync(data, { abortEarly: false });
    return { success: true };
  } catch (err) {
    const errorsObj = {};
    err.inner?.forEach((validationError) => {
      if (!errorsObj[validationError.path]) {
        errorsObj[validationError.path] = [];
      }
      errorsObj[validationError.path].push(validationError.message);
    });

    return { success: false, validationErrors: errorsObj };
  }
};

export const createValidationSchemas = () => [
  Yup.object({
    long_description: Yup.string().required("Long description is required"),
    short_description: Yup.string().required("Short description is required"),
    title: Yup.string().required("Title is required"),
    file: Yup.string().required("An image is required"),
    json_file: Yup.string().required("JSON file is required"),
  }),

  Yup.object({
    ai_models: Yup.string().required("Choose type of your mockup"),
    category: Yup.string().required("Category is required"),
    subcategory: Yup.string().required("Subcategory is required"),
  }),
];

export const createPaidValidationSchema = (minimumPrice) => {
  return Yup.object({
    ai_models: Yup.string().required("Choose type of your mockup"),
    price: Yup.number()
      .min(minimumPrice, `Price must be at least ${minimumPrice}$`)
      .required("Price is required"),
    category: Yup.string().required("Category is required"),
    subcategory: Yup.string().required("Subcategory is required"),
  });
};

